<template>
  <div class="pmenu">
    <div class="head">
      <a href="index.html">
        <img src="../../public/image/dddlogo2.png" alt="" class="logo" />
      </a>
      <div class="nav_box" @click="navactive = !navactive">
        <div class="nav" :class="{ active1: navactive }"></div>
        <div class="nav" :class="{ active2: navactive }"></div>
        <div class="nav" :class="{ active3: navactive }"></div>
      </div>
    </div>
    <div class="submenu" :class="{ active_sub: navactive }">
      <ul id="submenu">
        <li>
          <div class="t"><a href="index.html">{{$t('index')}}</a></div>
        </li>
        <li>
          <div class="t"><a href="about.html">{{$t('list')[0]}}</a><i>+</i></div>
          <div class="menulist">
            <div class="menuitem">
              <a href="about.html?index=0">{{$t('top').aList[0]}}</a>
            </div>
            <div class="menuitem">
              <a href="about.html?index=1">{{$t('top').aList[1]}}</a>
            </div>
            <div class="menuitem">
              <a href="culture.html?index=0">{{$t('top').aList[2]}}</a>
            </div>
            <!-- <div class="menuitem">
              <a href="about.html?index=3">{{$t('top').aList[3]}}</a>
            </div>
            <div class="menuitem">
              <a href="culture.html?index=0">{{$t('top').aList[4]}}</a>
            </div>
            <div class="menuitem">
              <a href="culture.html?index=1">{{$t('top').aList[5]}}</a>
            </div> -->
          </div>
        </li>
        
        <li>
          <div class="t"><a href="tech.html">{{$t('list')[2]}}</a><i>+</i></div>
          <div class="menulist">
            <div class="menuitem">
              <a href="tech.html?index=0">{{$t('top').tList[0]}}</a>
            </div>
            <div class="menuitem">
              <a href="tech.html?index=1">{{$t('top').tList[1]}}</a>
            </div>
            <div class="menuitem">
              <a href="tech.html?index=2">{{$t('top').tList[2]}}</a>
            </div>
            <div class="menuitem">
              <a href="tech.html?index=3">{{$t('top').tList[3]}}</a>
            </div>
          </div>
        </li>
        <li>
          <div class="t"><a href="duty.html">{{$t('list')[1]}}</a></div>
        </li>
        <li>
          <div class="t"><a href="news.html">{{$t('list')[3]}}</a><i>+</i></div>
          <div class="menulist">
            <div class="menuitem"><a href="news.html?index=0">{{$t('top').nList[0]}}</a></div>
            <div class="menuitem"><a href="news.html?index=1">{{$t('top').nList[1]}}</a></div>
          </div>
        </li>
        <li>
          <div class="t"><a href="contact.html">{{$t('list')[4]}}</a><i>+</i></div>
          <div class="menulist">
            <div class="menuitem"><a href="contact.html">{{$t('top').cList[0]}}</a></div>
            <div class="menuitem"><a href="message.html">{{$t('top').cList[1]}}</a></div>
            <div class="menuitem"><a href="human.html">{{$t('top').cList[2]}}</a></div>
          </div>
        </li>
        <li>
          <div class="t2">
            <span @click="changeLan('zh-CN')">CN</span>
            <span @click="changeLan('en')">EN</span>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { setup } from "../local/index";
export default {
  data() {
    return {
      navactive: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      $("#submenu")
        .find("i")
        .click(function () {
          var aaa = $(this).parents("li").children(".menulist").css("display");
          if (aaa == "none") {
            $("#submenu").find(".menulist").slideUp();
            $(this).parents("li").children(".menulist").slideDown();
            $(this).parents("li").siblings().css("opacity", "0.4");
            $(this).parents("li").css("opacity", "1");
          } else {
            $(this).parents("li").children(".menulist").slideUp();
            $("#submenu").find("li").css("opacity", "1");
          }
        });
    },
    changeLan(n) {
      this.$i18n.locale = n;
      window.localStorage.setItem("language", n);
      setup(n);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.pmenu {
  display: none;
  position: relative;
}
.head {
  width: 100%;
  background-color: #019bdb;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    width: 150px;
  }
  .nav_box {
    position: absolute;
    right: 20px;
    top: 18px;
    display: flex;
    flex-direction: column;
    height: 20px;
    justify-content: space-between;
    .nav {
      display: inline-block;
      background-color: white;
      width: 30px;
      height: 1px;
      transition: all 600ms;
    }
    .active1 {
      transform: rotate(-45deg) translateY(13px);
    }
    .active2 {
      transform: translateX(100px);
      opacity: 0;
    }
    .active3 {
      transform: rotate(45deg) translateY(-14px);
    }
  }
}
.submenu {
  position: absolute;
  top: 60px;
  height: 100vh;
  width: 100%;
  background-color: rgba(1, 154, 219, 0.6);
  backdrop-filter: blur(10px);
  transform: translateY(-120vh);
  z-index: -1;
  transition: all 600ms;
  // filter: blur(100px);
  ul {
    li {
      list-style: none;
      padding: 10px 0;
      width: 80%;
      margin: 0 auto;
      // border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      .t {
        display: flex;
        // justify-content: center;
        align-items: center;
        a {
          color: white;
          display: inline-block;
          width: 50%;
          margin-left: 25%;
          text-align: center;
          font-family: "SOURCEHANSANSCN-NORMAL";
        }
        i {
          font-style: normal;
          font-size: 22px;
          color: white;
          margin-left: auto;
          margin-right: 40px;
        }
      }
      .t2{
        display: flex;
        justify-content: center;
        span{
          display: inline-block;
          color: white;
        }
        span:nth-child(1){
          margin-right: 40px;
        }
      }
      .menulist {
        width: 70%;
        margin: 10px auto;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        display: none;
        .menuitem {
          display: flex;
          justify-content: center;
          padding: 10px 0;
          a {
            color: white;
            font-size: 14px;
            font-family: "SOURCEHANSANSCN-NORMAL";
          }
        }
      }
    }
  }
}
.active_sub {
  transform: translateY(0);
}
@media screen and (max-width: 1000px) {
  .pmenu {
    display: block;
  }
}
</style>
